var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRs = function SvgRs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 0C5.373 0 0 5.373 0 12c0 1.468.264 2.874.746 4.174h22.508c.482-1.3.746-2.706.746-4.174 0-6.627-5.373-12-12-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 0C6.842 0 2.444 3.257.748 7.826h22.507C21.56 3.256 17.16 0 12.001 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.104 6.783v5.986c0 3.406 4.448 4.449 4.448 4.449S12 16.175 12 12.769V6.783H3.104Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M4.942 7.826h5.218V5.74l-1.044.522-1.565-1.565L5.986 6.26 4.942 5.74v2.087ZM10.957 13.603 7.565 10.21l-3.391 3.392 1.107 1.106 2.284-2.284 2.285 2.284 1.107-1.106Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M10.957 10.434H9.373A1.043 1.043 0 1 0 7.551 9.42a1.043 1.043 0 1 0-1.822 1.014H4.174c0 .576.502 1.044 1.078 1.044h-.035c0 .576.467 1.043 1.044 1.043 0 .51.366.934.85 1.025l-.822 1.856a3.38 3.38 0 0 0 2.552 0l-.822-1.856c.484-.09.85-.515.85-1.025.577 0 1.044-.467 1.044-1.043h-.035c.576 0 1.079-.468 1.079-1.044Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgRs;